webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    todos: function todos() {
      return this.$store.getters.workinprogress;
    }
  },
  methods: {
    remove: function remove(todo) {
      if (window.confirm('Are sure want to delete this task?')) {
        this.$store.dispatch('removeTodo', todo.id);
      }
    },
    becomeTesting: function becomeTesting(todo) {
      this.$store.dispatch('becomeTesting', todo);
    },
    becomeTasktodo: function becomeTasktodo(todo) {
      this.$store.dispatch('becomeTasktodo', todo);
    }
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(192),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(194),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b04dc490",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(190),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(189),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(193),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(188),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 187:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Kanban Cute")]), _vm._v(" "), _c('div', {}, [_c('b-btn', {
    on: {
      "click": function($event) {
        _vm.$root.$emit('show::modal', 'modal1')
      }
    }
  }, [_vm._v("Add a Card")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal1",
      "title": "Add Card"
    }
  }, [_c('form', [_c('p', [_vm._v("Task: ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "--Title task--"
    },
    model: {
      value: (_vm.task),
      callback: function($$v) {
        _vm.task = $$v
      },
      expression: "task"
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Description: ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "rows": "4",
      "cols": "50"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Assigned To: ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "--Assigned To--"
    },
    model: {
      value: (_vm.assignee),
      callback: function($$v) {
        _vm.assignee = $$v
      },
      expression: "assignee"
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Point:")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "--Point--"
    },
    model: {
      value: (_vm.point),
      callback: function($$v) {
        _vm.point = $$v
      },
      expression: "point"
    }
  }), _c('br'), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "success"
    },
    on: {
      "click": _vm.addTask
    }
  }, [_vm._v("Submit")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "mb-2 card-info cardhead",
    attrs: {
      "id": "drag1",
      "header": "Work In Progress"
    }
  }, _vm._l((_vm.todos), function(todo, index) {
    return _c('b-card', {
      key: todo.id,
      staticClass: "mb-2 cardcontent",
      attrs: {
        "header": todo.task
      }
    }, [_c('p', [_vm._v("(" + _vm._s(todo.point) + ") Assigned to: " + _vm._s(todo.assignee) + " ")]), _vm._v(" "), _c('b-btn', {
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', todo.id.toString())
        }
      }
    }, [_vm._v("Detail")]), _vm._v(" "), _c('b-modal', {
      attrs: {
        "id": todo.id.toString(),
        "title": todo.task
      }
    }, [_c('form', [_c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Detail: " + _vm._s(todo.description))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Story Point: " + _vm._s(todo.point))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Assigned to: " + _vm._s(todo.assignee))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          _vm.becomeTasktodo(todo)
        }
      }
    }, [_vm._v("Change to Task To-Do")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.remove(todo)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.becomeTesting(todo)
        }
      }
    }, [_vm._v("Changet to Testing")])], 1)])])], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "mb-2 card-danger cardhead",
    attrs: {
      "header": "Task To-Do"
    }
  }, _vm._l((_vm.todos), function(todo, index) {
    return _c('b-card', {
      key: todo.id,
      staticClass: "mb-2 cardcontent",
      attrs: {
        "header": todo.task
      }
    }, [_c('p', [_vm._v("(" + _vm._s(todo.point) + ") Assigned to: " + _vm._s(todo.assignee))]), _vm._v(" "), _c('b-btn', {
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', todo.id.toString())
        }
      }
    }, [_vm._v("Detail")]), _vm._v(" "), _c('b-modal', {
      attrs: {
        "id": todo.id.toString(),
        "title": todo.task
      }
    }, [_c('form', [_c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Description: " + _vm._s(todo.description))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Story Point: " + _vm._s(todo.point))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Assigned to: " + _vm._s(todo.assignee))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.remove(todo)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function($event) {
          _vm.becomeWorkinprogress(todo)
        }
      }
    }, [_vm._v("Change To Work In Progress")])], 1)])])], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Navbar'), _vm._v(" "), _c('Maincontent')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "mb-2 card-success cardhead",
    attrs: {
      "header": "Done"
    }
  }, _vm._l((_vm.todos), function(todo, index) {
    return _c('b-card', {
      key: todo.id,
      staticClass: "mb-2 cardcontent",
      attrs: {
        "header": todo.task
      }
    }, [_c('p', [_vm._v("(" + _vm._s(todo.point) + ") Assigned to: " + _vm._s(todo.assignee) + " ")]), _vm._v(" "), _c('b-btn', {
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', todo.id.toString())
        }
      }
    }, [_vm._v("Detail")]), _vm._v(" "), _c('b-modal', {
      attrs: {
        "id": todo.id.toString(),
        "title": todo.task
      }
    }, [_c('form', [_c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Description: " + _vm._s(todo.description))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Story Point: " + _vm._s(todo.point))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Assigned to: " + _vm._s(todo.assignee))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.becomeTesting(todo)
        }
      }
    }, [_vm._v("Change To Testing")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.remove(todo)
        }
      }
    }, [_vm._v("Delete")])], 1)])])], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "mb-2 card-info cardhead",
    attrs: {
      "header": "Testing"
    }
  }, _vm._l((_vm.todos), function(todo, index) {
    return _c('b-card', {
      key: todo.id,
      staticClass: "mb-2 cardcontent",
      attrs: {
        "header": todo.task
      }
    }, [_c('p', [_vm._v("(" + _vm._s(todo.point) + ") Assigned to: " + _vm._s(todo.assignee) + " ")]), _vm._v(" "), _c('b-btn', {
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', todo.id.toString())
        }
      }
    }, [_vm._v("Detail")]), _vm._v(" "), _c('b-modal', {
      attrs: {
        "id": todo.id.toString(),
        "title": todo.task
      }
    }, [_c('form', [_c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Description: " + _vm._s(todo.description))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Story Point: " + _vm._s(todo.point))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Assigned to: " + _vm._s(todo.assignee))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          _vm.becomeWorkinprogress(todo)
        }
      }
    }, [_vm._v("Change To Work In Progress")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.remove(todo)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "success"
      },
      on: {
        "click": function($event) {
          _vm.becomeDone(todo)
        }
      }
    }, [_vm._v("Change To Done")])], 1)])])], 1)
  }))
},staticRenderFns: []}

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('Tasktodo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('Workinprogress')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('Testing')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('Done')], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Page__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Page',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Page___default.a
  }]
}));

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(197);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var config = {
  apiKey: 'AIzaSyBPxwiFOxz-aEeBfiLBDZ0027X17sjJr4Q',
  databaseURL: 'https://kanbancute.firebaseio.com',
  projectId: 'kanbancute'
};
var db = __WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](config).database();
var todosRef = db.ref('todos');

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    todos: []
  },
  mutations: {
    getTodos: function getTodos(state) {
      todosRef.on('value', function (snapshot) {
        state.todos = [];
        for (var prop in snapshot.val()) {
          state.todos.push(snapshot.val()[prop]);
        }
      });
    }
  },
  actions: {
    addTodo: function addTodo(store, context) {
      if (store.state.todos.length > 0) {
        var idx = store.state.todos[store.state.todos.length - 1].id + 1;
        db.ref('todos/' + idx).set({
          id: idx,
          task: context.task,
          description: context.description,
          assignee: context.assignee,
          point: context.point,
          status: context.status
        });
      } else {
        db.ref('todos/1').set({
          id: 1,
          task: context.task,
          description: context.description,
          assignee: context.assignee,
          point: context.point,
          status: context.status
        });
      }
    },
    removeTodo: function removeTodo(state, context) {
      db.ref('todos/' + context).remove();
    },
    becomeTasktodo: function becomeTasktodo(state, context) {
      db.ref('todos/' + context.id).set({
        id: context.id,
        task: context.task,
        description: context.description,
        assignee: context.assignee,
        point: context.point,
        status: 'tasktodo'
      });
    },
    becomeWorkinprogress: function becomeWorkinprogress(state, context) {
      db.ref('todos/' + context.id).set({
        id: context.id,
        task: context.task,
        description: context.description,
        assignee: context.assignee,
        point: context.point,
        status: 'workinprogress'
      });
    },
    becomeTesting: function becomeTesting(state, context) {
      db.ref('todos/' + context.id).set({
        id: context.id,
        task: context.task,
        description: context.description,
        assignee: context.assignee,
        point: context.point,
        status: 'testing'
      });
    },
    becomeDone: function becomeDone(state, context) {
      db.ref('todos/' + context.id).set({
        id: context.id,
        task: context.task,
        description: context.description,
        assignee: context.assignee,
        point: context.point,
        status: 'done'
      });
    }
  },
  getters: {
    tasktodo: function tasktodo(state) {
      return state.todos.filter(function (todo) {
        return todo.status === 'tasktodo';
      });
    },
    workinprogress: function workinprogress(state) {
      return state.todos.filter(function (todo) {
        return todo.status === 'workinprogress';
      });
    },
    testing: function testing(state) {
      return state.todos.filter(function (todo) {
        return todo.status === 'testing';
      });
    },
    done: function done(state) {
      return state.todos.filter(function (todo) {
        return todo.status === 'done';
      });
    }
  }
});

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(191),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_store__ = __webpack_require__(87);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store_store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    todos: function todos() {
      return this.$store.getters.done;
    }
  },
  methods: {
    remove: function remove(todo) {
      if (window.confirm('Are you sure want to delete this task?')) {
        this.$store.dispatch('removeTodo', todo.id);
      }
    },
    becomeTesting: function becomeTesting(todo) {
      this.$store.dispatch('becomeTesting', todo);
    }
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tasktodo__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tasktodo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tasktodo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Workinprogress__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Workinprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Workinprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Testing__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Testing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Testing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Done__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Done__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tasktodo: __WEBPACK_IMPORTED_MODULE_0__components_Tasktodo___default.a,
    Workinprogress: __WEBPACK_IMPORTED_MODULE_1__components_Workinprogress___default.a,
    Testing: __WEBPACK_IMPORTED_MODULE_2__components_Testing___default.a,
    Done: __WEBPACK_IMPORTED_MODULE_3__components_Done___default.a
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      task: null,
      assignee: null,
      point: null,
      description: null
    };
  },

  methods: {
    addTask: function addTask(event) {
      event.preventDefault();
      if (this.task && this.assignee && !isNaN(this.point)) {
        var payload = {
          task: this.task,
          description: this.description,
          assignee: this.assignee,
          point: this.point,
          status: 'tasktodo'
        };
        this.task = '';
        this.description = '';
        this.assignee = '';
        this.point = '';
        this.$store.dispatch('addTodo', payload);
        this.$root.$emit('hide::modal', 'modal1');
      }
    }
  }
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Maincontent__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Maincontent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Maincontent__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default.a,
    Maincontent: __WEBPACK_IMPORTED_MODULE_1__components_Maincontent___default.a
  },
  created: function created() {
    this.$store.commit('getTodos');
  }
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    todos: function todos() {
      return this.$store.getters.tasktodo;
    }
  },
  methods: {
    remove: function remove(todo) {
      if (window.confirm('Are you sure want to delete this task?')) {
        this.$store.dispatch('removeTodo', todo.id);
      }
    },
    becomeWorkinprogress: function becomeWorkinprogress(todo) {
      this.$store.dispatch('becomeWorkinprogress', todo);
    }
  }
});

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    todos: function todos() {
      return this.$store.getters.testing;
    }
  },
  methods: {
    remove: function remove(todo) {
      if (window.confirm('Are you sure want to delete this task?')) {
        this.$store.dispatch('removeTodo', todo.id);
      }
    },
    becomeWorkinprogress: function becomeWorkinprogress(todo) {
      this.$store.dispatch('becomeWorkinprogress', todo);
    },
    becomeDone: function becomeDone(todo) {
      this.$store.dispatch('becomeDone', todo);
    }
  }
});

/***/ })

},[92]);


// WEBPACK FOOTER //
// static/js/app.7e9c393e15b24faed018.js